import {useRef,useEffect} from 'react'

import CartClasses from '../components/Cart/Cart.module.css';


const TouchNet = () => {
	const ticket = sessionStorage.getItem('Ticket');
	const ticketname = sessionStorage.getItem('Labid') + ":" + sessionStorage.getItem('Labtestid')

	let form=useRef();

	useEffect(()=>{
	  form.current.submit();
	},[])
   return (<div className={CartClasses.testInfo}>
    	    <div className={CartClasses.testInfoContent}>
				<form method='post' ref={form} name="touchNetForm" action="https://test.secure.touchnet.net:8443/C30002test_upay/web/index.jsp">
					<input type="hidden" name="UPAY_SITE_ID" value="326" />
					<input type="hidden" name="TICKET" value= {ticket} />
					<input type="hidden" name="TICKET_NAME" value= {ticketname} />
				</form>
			</div>
		   </div>
	);
}

export default TouchNet;


